/**
 * @description Get the aa account value
 * @param { ppProfile: PpProfile, defaultAaAccount: string, tealiumEnvironment: string } param0
 * @returns { aaAccount: string }
 */
export const getAaAccountValue = ({
	ppProfile,
	defaultAaAccount,
	tealiumEnvironment,
}: {
	ppProfile?: {
		agencyName?: string;
		advisorId?: string;
		email?: string;
	};
	defaultAaAccount?: string;
	tealiumEnvironment?: string;
}) => {
	const PP_EXTERNAL_REPORT_SUITE = 'fshppexternal';

	const aaAccount = ppProfile
		? defaultAaAccount
			? tealiumEnvironment === 'prod' && !defaultAaAccount.includes(PP_EXTERNAL_REPORT_SUITE)
				? `${defaultAaAccount},${PP_EXTERNAL_REPORT_SUITE}`
				: defaultAaAccount
			: tealiumEnvironment !== 'prod'
				? `fshglobaldev`
				: `fshglobal,fshppexternal`
		: undefined;

	return aaAccount;
};

/**
 * @description Get the pp analytics values for the pp profile
 * @param { ppProfile: PpProfile, defaultAaAccount: string, tealiumEnvironment: string; allowAnonymousOnPP: boolean; ppMode: boolean; } param0
 * @returns
 */
export const getPPAnalyticsValues = ({
	ppProfile,
	defaultAaAccount,
	tealiumEnvironment,
	allowAnonymousOnPP = false,
	ppMode,
}: {
	ppProfile?: {
		agencyName?: string;
		advisorId?: string;
		email?: string;
	};
	defaultAaAccount?: string;
	tealiumEnvironment?: string;
	allowAnonymousOnPP?: boolean;
	ppMode?: boolean;
}) => {
	// No ppMode, return an empty object
	if (!ppMode) {
		return {};
	}
	// No pp profile, no allowAnonymousOnPP, return an empty object
	if (!ppProfile && !allowAnonymousOnPP) {
		return {};
	}

	// Default values for ppMode on anonymous pp
	const aaAccount = getAaAccountValue({
		ppProfile: ppProfile || {},
		defaultAaAccount,
		tealiumEnvironment,
	});
	const userType = !ppProfile
		? 'visitor'
		: tealiumEnvironment === 'prod'
			? 'preferred partner'
			: 'pp internal';

	if (!ppProfile && allowAnonymousOnPP) {
		return {
			user_type: userType,
			aa_account: aaAccount,
			login_state: 'anonymous',
		};
	}

	const { agencyName, advisorId } = ppProfile ?? {};

	const loginState = ppProfile ? 'fully authenticated' : 'anonymous';

	return {
		...(agencyName ? { pp_agency: agencyName } : {}),
		...(advisorId ? { pp_id: advisorId } : {}),
		...(userType ? { user_type: userType } : {}),
		...(aaAccount ? { aa_account: aaAccount } : {}),
		...(loginState ? { login_state: loginState } : {}),
	};
};
